import { z } from "zod";

// Schemas

export const DurationSchema = z.enum(["forever", "once", "repeating"]);

export const CouponSchema = z.object({
  id: z.string(),
  object: z.string(),
  amount_off: z.number().nullable(),
  percent_off: z.number().nullable(),
  name: z.string().nullable(),
  duration: DurationSchema,
  applies_to: z.object({ products: z.string().array() }).optional(),
  duration_in_months: z.number().nullable(),
  valid: z.boolean(),
});

export const PromotionCodeSchema = z.object({
  id: z.string(),
  code: z.string(),
  coupon: CouponSchema,
});

export const StripeCheckoutSessionStatusSchema = z.enum([
  "complete",
  "expired",
  "open",
]);

export const StripeSubscriptionStatusSchema = z.enum([
  "active",
  "canceled",
  "incomplete",
  "incomplete_expired",
  "past_due",
  "paused",
  "trialing",
  "unpaid",
]);
